import { EmployeeConfig } from '@domain/configuration/types/employee-config';
import { useGeneratedSalesPortalEmployeeConfigQuery } from '@/domain/configuration/blocs/documents/employee-config.generated';

/**
 * Loads and validates the employee's {@link EmployeeConfig} for a supplier.
 *
 * @param supplierUUID - Supplier whose config to load.
 * @param userUUID - Employee whose config to load.
 * @returns The parsed {@link EmployeeConfig} and the query loading state.
 */
export const useEmployeeConfigLoader = (
  supplierUUID: string,
  userUUID: string,
): { employeeConfig: EmployeeConfig; loading: boolean } => {
  const { data, loading } = useGeneratedSalesPortalEmployeeConfigQuery({
    variables: {
      supplierUUID,
      userUUID,
    },
  });

  return {
    employeeConfig: EmployeeConfig.schema.parse(
      data?.businesses_by_pk?.businesses_employees?.[0]?.employee_config ?? {},
    ),
    loading,
  };
};
